import { create } from "zustand";

import { CurrentSlice, createCurrentSlice } from "./current-slice";
import { createLayoutSlice, LayoutSlice } from "./layout-slice";
import { createLegacySlice, LegacySlice } from "./legacy-slice";
import { createSimpleModalSlice, SimpleModalSlice } from "./simple-modal-slice";

export const useStore = create<CurrentSlice & LayoutSlice & LegacySlice & SimpleModalSlice>()((...a) => ({
    ...createCurrentSlice(...a),
    ...createLayoutSlice(...a),
    ...createLegacySlice(...a),
    ...createSimpleModalSlice(...a),
}));
